import React, { memo } from 'react';
import { Box, HStack, Text } from 'native-base';
import { GreenTickIcon, InfoIcon } from '../../assets';
const MessageRow = _ref => {
  let {
    color = '#0a4a8d',
    text,
    opacity,
    maxW = '100%'
  } = _ref;
  return /*#__PURE__*/React.createElement(HStack, {
    space: 1
  }, /*#__PURE__*/React.createElement(Box, null, color === '#03906A' ? /*#__PURE__*/React.createElement(GreenTickIcon, null) : /*#__PURE__*/React.createElement(InfoIcon, {
    color: color
  })), /*#__PURE__*/React.createElement(Text, {
    flex: 2,
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    color: color,
    opacity: opacity,
    accessibilityLabel: text,
    testID: text,
    maxW: maxW
  }, text));
};
export default /*#__PURE__*/memo(MessageRow);
//# sourceMappingURL=index.js.map